import React from "react";
import { LoadingOutlined, PlayCircleOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";

interface VideoPreviewProps {
  src: string;
  onPreview: () => void;
  onRemove: (e: React.MouseEvent) => void;
  loading?: boolean;
  styles: any;
}

export const VideoPreview: React.FC<VideoPreviewProps> = React.memo(
  ({ src, onPreview, onRemove, loading, styles }) => {
    const intl = useIntl();

    return (
      <div className={styles.imagePreview}>
        <div
          className={styles.videoThumbWrapper}
          style={{ opacity: loading ? 0.6 : 1 }}
          onClick={onPreview}
        >
          <img
            src={src}
            alt={intl.formatMessage({ id: "video.thumbnail.alt" })}
            className={styles.videoThumbImage}
          />
          <PlayCircleOutlined className={styles.videoPlayIcon} />
        </div>
        <span className={styles.removeImage} onClick={onRemove}>
          ×
        </span>
        {loading && (
          <div className={styles.imageLoading}>
            <LoadingOutlined className={styles.blueIconSmall} />
          </div>
        )}
      </div>
    );
  }
);

VideoPreview.displayName = "VideoPreview";
